module.exports = new __parcel__URL__("vibe-3.22159210.json").toString();